<mat-toolbar
        [ngStyle]="{backgroundColor:settings ? settings.value.headerColor : '#d0d0ce', color: settings ? settings.value.headerTextColor : '#000000'}">
    <div class="logo-container" routerLink="/">
        <a class="yi-logo"></a>
    </div>
    <!-- open menu -->
    <div class="left-fill">
        <button class="menu-button" (click)="toggleMenu()" matMiniFab>
            <mat-icon>menu</mat-icon>
        </button>
    </div>

    <!-- This fills the remaining space of the current row -->
    @if (settings ? settings.value.headerLogoUrl === '' : true) {
        <span class="center-fill">
      {{ authDomain }}
    </span>
    }

    @if (settings ? settings.value.headerLogoUrl !== '' : false) {
        <div
                class="center-fill header-logo-container">
            <img [alt]="authDomain" [src]="settings.value.headerLogoUrl" class="header-logo">
        </div>
    }

    <div class="right-fill">
        <button mat-button [matMenuTriggerFor]="menu" class="user-menu-button">
            <span class="user-menu-content">
                @if (loggedUserPhoto) {
                    <img [src]="loggedUserPhoto" alt="Avatar" class="avatar">
                } @else {
                    <mat-icon>person</mat-icon>
                }
                <span class="username">{{ loggedUser }}</span>
            </span>
        </button>
        <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="logoutUser()">
                <mat-icon>exit_to_app</mat-icon>
                <span>Logout</span>
            </button>
        </mat-menu>
    </div>

</mat-toolbar>